import React from 'react';
import { Typography, Box } from '@mui/material';
import { DateTime } from 'luxon';
import { MoSpacing } from '@motivo/guanyin/src/components';
import { ResultOf } from ':src/graphql';
import { organizationAdminDetailsByIdQuery } from '../../graphql/queries';
import { Section } from '../Section';

type OrganizationAdmin = NonNullable<
  ResultOf<typeof organizationAdminDetailsByIdQuery>['organizationAdminById']
>;

interface OnboardingsSectionProps {
  organizationAdmin: OrganizationAdmin;
}

export default function OnboardingsSection({ organizationAdmin }: OnboardingsSectionProps) {
  const { organization } = organizationAdmin;
  const onboardings = organization.organizationOnboardings;

  if (onboardings.length === 0) {
    return null;
  }

  return (
    <Section title="Onboarding status">
      <MoSpacing y={2}>
        {onboardings.map((onboarding) => {
          const mostRecentComment = onboarding.organizationOnboardingComments[0];

          return (
            <Box key={onboarding.id}>
              <MoSpacing y={0.5}>
                <Box>
                  <Typography fontWeight={600}>{onboarding.usState?.name || 'Overall'}</Typography>
                  <Typography variant="body2">{onboarding.onboardingStatus.name}</Typography>
                </Box>
                {mostRecentComment && (
                  <Box
                    sx={{
                      pl: 2,
                      borderLeft: '2px solid',
                      borderColor: 'divider',
                    }}
                  >
                    <Typography variant="body2" color="textSecondary" fontSize="0.75rem">
                      {mostRecentComment.submittedByAdmin.fullName} •{' '}
                      {DateTime.fromISO(mostRecentComment.createdAt).toFormat('MMM d, yyyy')}
                    </Typography>
                    <Typography variant="body2">{mostRecentComment.comment}</Typography>
                  </Box>
                )}
              </MoSpacing>
            </Box>
          );
        })}
      </MoSpacing>
    </Section>
  );
}
